<form [action]="redirectUrl" role="search" method="GET">
  <input
    id="autocomplete-search"
    type="text"
    name="query"
    role="combobox"
    autocomplete="off"
    autocapitalize="none"
    aria-autocomplete="list"
    aria-owns="autocomplete-search-options"
    (keydown)="onKeydown($event)"
    [formControl]="search"
    [placeholder]="placeholder"
    [attr.aria-expanded]="hits.length"
  />
  <button>
    <ng-content></ng-content>
  </button>
  <ul id="autocomplete-search-options" role="listbox">
    <li
      #optionElement
      role="option"
      tabindex="-1"
      [id]="hit.query"
      (click)="onClick($event)"
      (keydown)="onKeydown($event)"
      *ngFor="let hit of hits"
    >
      {{ hit.query }}
    </li>
  </ul>
</form>
